import { useEffect } from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Definitions from "../definitions";
import { ItemStatus, DisplayStatus } from "./Helper";

const exampleData = {
  id: "1570",
  title: "Mindfulness – As a Counselling Tool &#8211; Part 2 Webinar",
  img: "https://local-ctri.local/wp-content/uploads/2021/10/876a06be453aa2187eaddf779544c77e_big.jpg",
  content_type: "on-demand-webinar",
  tag: "library",
  latest_expiration_date: "1642027467",
  active: [
    {
      id: "5",
      share_user_id: null,
      expiry: "1642027467",
    },
  ],
  expired: [],
  license_count: 1,
  license_used: 0,
};

function ProductCard({ item, itemClick, openShare }) {
  const productImg =
    item.img !== false
      ? item.img
      : "/wp-content/themes/hello/static/images/Default-Library.jpg";
  const productThumb = (
    <div
      className="product_card__thumb"
      onClick={() => itemClick(item)}
      style={{ backgroundImage: 'url("' + productImg + '")' }}
    ></div>
  );

  const convertedDate = () => {
    if (item.content_type != "e-manual" && item.content_type != "e-course" && item.content_type != "certificate-self-guided") {
      if (
        item?.latest_expiration_date &&
        item?.latest_expiration_date != "0" &&
        item?.latest_expiration_date != 0 &&
        item?.latest_expiration_date != ""
      ) {
        const date = new Date(parseInt(item.latest_expiration_date + "000"));
        var options = { year: "numeric", month: "short", day: "numeric" };
        var expired_str = "Expires";
        if (isExpired) {
          expired_str = "Expired";
        }
        return expired_str + " " + date.toLocaleDateString("en-US", options);
      }
    }
  };

  const isExpired =
    item.content_type != "e-manual" &&
    item.content_type != "e-course" &&
    item.content_type != "certificate-self-guided" &&
    item.latest_expiration_date < Date.now() / 1000;

  const activeLicenseCount = () => {
    let license_used = item.license_used ? item.license_used : 0;
    let license_count = item.license_count ? item.license_count : 0;
    let expired_count = item.expired ? item.expired.length : 0;

    if (item.tag === "membership") {
      return license_count - license_used;
    }

    return license_count - expired_count - license_used;
  };

  const shares =
    !isExpired &&
      item.tag !== "member" &&
      item.tag !== "contract" &&
      item.tag !== "free" &&
      item.tag !== "shared" ? (
      <Col className="product_card__info--smalltext">
        Remaining Licenses: {activeLicenseCount()}
      </Col>
    ) : (
      ""
    );

  const isSharedContent =
    item.tag === "shared" ? (
      <>
        <Col className="product_card__info--smalltext info__tag info__tag--shared">
          Shared Content
        </Col>
        {item.shared_by ? (
          <Col className="product_card__info--smalltext info__tag info__tag--shared">
            Shared by: {item.shared_by}
          </Col>
        ) : (
          ""
        )}
      </>
    ) : (
      ""
    );

  const isMemberContent =
    item.tag === "member" ? (
      <Col
        className="product_card__info--smalltext info__tag info__tag--member"
        onClick={() => itemClick(item)}
      >
        Member Content
      </Col>
    ) : (
      ""
    );

  const isEcourseContent =
    item.content_type === "e-course" ? (
      <>
        <Col className="product_card__info--smalltext" >Please click ‘View Course’ to manage access to your E-Course.</Col>
        <Col className="product_card__info--smalltext info__tag info__tag--member" onClick={() => itemClick(item)}>
          View Course
        </Col>
      </>
    ) : (
      ""
    );

  const isCertificateContent =
    item.content_type === "certificate-self-guided" ? (
      <>
        <Col className="product_card__info--smalltext info__tag info__tag--member" onClick={() => itemClick(item)}>
          View Certificate
        </Col>
      </>
    ) : (
      ""
    );

  const isContractContent =
    item.tag === "contract" ? (
      <Col className="product_card__info--smalltext info__tag info__tag--contract">
        Contract Content
      </Col>
    ) : (
      ""
    );

  const isFreeContent =
    item.tag === "free" ? (
      <Col className="product_card__info--smalltext info__tag info__tag--free">
        Free Content
      </Col>
    ) : (
      ""
    );

  const shareButton =
    item?.license_count > 0 &&
      item.tag !== "member" &&
      item.tag !== "shared" &&
      item.tag !== "free" &&
      item.tag !== "contract" ? (
      <Row className="product_card__share__container">
        <Button
          className="product_card__share--button"
          onClick={() => openShare(item)}
        >
          Share
        </Button>
      </Row>
    ) : (
      ""
    );

  const expired_class = isExpired ? "product_card--expired" : "";

  const content_type =
    item?.content_type && Definitions[item?.content_type]?.alt ? (
      <div className="product_card__content-type">
        {Definitions[item?.content_type]?.alt}
      </div>
    ) : (
      ""
    );


  const padTop = DisplayStatus(item) ? " product_card__title--pad-top " : "";

  return (
    <Card key={item.id} className={"product_card " + expired_class + padTop}>
      {productThumb}
      <Card.Body className="product_card__main">
        {item && item?.status ? <ItemStatus item={item} /> : null}
        <Col className="product_card__title__container">
          {content_type}
          <Card.Title
            className="product_card__title"
            onClick={() => itemClick(item)}
            dangerouslySetInnerHTML={{ __html: item?.title }}
          ></Card.Title>
          <Card.Subtitle
            className="product_card__subtitle"
            onClick={() => itemClick(item)}
            dangerouslySetInnerHTML={{ __html: item?.subtitle }}
          ></Card.Subtitle>
        </Col>

        <Col className="product_card__info__container">

          {convertedDate()}
          {shares}
          {isSharedContent}
          {isMemberContent}
          {isContractContent}
          {isEcourseContent}
          {isCertificateContent}
          {isFreeContent}
          {shareButton}
        </Col>
      </Card.Body>
    </Card>
  );
}
export default ProductCard;
